var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { CircularProgress, Box } from '@mui/material';
import { useEffect } from 'react';
var Loading = function () {
    var loading = true;
    useEffect(function () {
        document.body.style.overflow = loading ? 'hidden' : '';
        return function () {
            document.body.style.overflow = '';
        };
    }, [loading]);
    return (_jsx(Box, __assign({ sx: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            zIndex: 10000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(2px)',
        } }, { children: _jsx(CircularProgress, { sx: { color: '#00673D' }, size: 48, thickness: 4 }) })));
};
export default Loading;
